import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAccessibility = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconAccessibility",
  viewBox: "0 0 16 18",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M8 3.94A1.97 1.97 0 1 0 8 0a1.97 1.97 0 0 0 0 3.94"
  }), _jsx("path", {
    d: "M14.19 3.97h-.03l-.11.03c-.65.2-3.83 1.1-6.07 1.1a26 26 0 0 1-6.17-1.14C1.14 3.8.68 4.46.68 5.08S1.24 6 1.8 6.2v.01l3.35 1.05c.34.13.43.26.48.38.14.37.02 1.1-.01 1.36l-.2 1.59-1.14 6.2v.05l-.01.04c-.09.57.33 1.12 1.12 1.12.69 0 1-.47 1.13-1.12 0 0 .98-5.54 1.47-5.54.5 0 1.5 5.54 1.5 5.54.14.65.44 1.12 1.13 1.12.8 0 1.21-.55 1.13-1.12l-.03-.15-1.14-6.14-.2-1.58c-.16-.92-.04-1.23 0-1.3s.22-.23.62-.38l3.14-1.1.06-.02c.56-.2 1.12-.5 1.12-1.12s-.45-1.3-1.12-1.12"
  })]
}));
IconAccessibility.displayName = 'IconAccessibility';